import { render, staticRenderFns } from "./WordpressPagination.vue?vue&type=template&id=b2b1bfb0"
import script from "./WordpressPagination.vue?vue&type=script&lang=js"
export * from "./WordpressPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports